<template>
  <div class="move mv1 is-fullwidth">
    <h2>Move "{{ question.title }}" to</h2>

    <table class="table">
      <thead>
        <th>Page</th>
        <th>Position</th>
        <th>Question</th>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="select">
              <select v-model="pageId">
                <option v-for="page in Object.values(pages)" :value="page.id">{{
                  page.attributes.title
                }}</option>
              </select>
            </div>
          </td>
          <td>
            <div class="select">
              <select v-model="position">
                <option value="before">before</option>
                <option value="after">after</option>
              </select>
            </div>
          </td>
          <td>
            <div class="select">
              <select v-model="positionQuestionId">
                <option v-for="q in questions" :value="q.id">{{
                  q.title
                }}</option>
              </select>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="field is-grouped mt2 has-text-right">
      <div class="control">
        <button
          type="button"
          :class="['button', 'is-primary', { 'is-loading': loading }]"
          @click="move"
        >
          Move
        </button>
        <button type="button" class="button is-link" @click="$emit('hide')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";

export default {
  name: "question-move",

  props: ["question"],

  data() {
    return {
      loading: false,
      pageId: null,
      position: "before",
      positionQuestionId: 0
    };
  },

  computed: {
    pageIdOrInterviewPageId() {
      return this.pageId || this.question.interviewPageId;
    },
    questions() {
      return this.pages[this.pageIdOrInterviewPageId].attributes.questions;
    },
    pages() {
      return this.$store.state.interview.pages;
    }
  },

  methods: {
    move() {
      this.loading = true;
      const interviewId = this.$route.params.id;
      InterviewsService.moveQuestion(
        this.question.id,
        this.pageId,
        this.position,
        this.positionQuestionId,
        interviewId
      ).then(() => {
        this.loading = false;
        this.$emit("hide");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.move {
  padding: 1rem;
}
</style>
